import { Component, DestroyRef, inject, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { EMPTY } from "rxjs";
import { catchError } from "rxjs/operators";
import { register } from "timeago.js";
import { fr } from "timeago.js/lib/lang";

import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { AppService } from "./store/app.service";

@Component({
    selector: "jpgrondin-app",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.style.scss"],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
    private readonly service = inject(AppService);
    private readonly destroyRef = inject(DestroyRef);

    public async ngOnInit(): Promise<void> {
        register("fr", fr);
        this.service.loadServerState().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
        this.service
            .loadCurrentAccount()
            .pipe(
                catchError(() => EMPTY),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe();
    }
}
